import { Nullable } from 'models/helpers'
import { PreferredPaymentMethodType } from 'models/user'
import { PreferredPaymentMethodEnum } from 'constants/user'

/**
 * Whether the client is offered the preferred payment method choice: when there is more than one
 * method to pick from, and also when the saved one is no longer available to them (for example after
 * their organization moved to periodic invoicing), so they can change or clear it.
 * Nothing is offered until the available methods have loaded.
 */
export const offersPreferredPaymentMethodChoice = (
  availableMethods: ReadonlyArray<PreferredPaymentMethodType>,
  savedMethod: Nullable<PreferredPaymentMethodType> | undefined
): boolean => {
  if (availableMethods.length === 0) return false
  if (availableMethods.length > 1) return true
  return !!savedMethod && savedMethod !== PreferredPaymentMethodEnum.NONE && !availableMethods.includes(savedMethod)
}
